import { render } from "./page-video.vue?vue&type=template&id=bfdbdff6&ts=true"
import script from "./page-video.vue?vue&type=script&lang=ts"
export * from "./page-video.vue?vue&type=script&lang=ts"

import "./page-video.vue?vue&type=style&index=0&id=bfdbdff6&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__